import React from 'react';
import { Link } from 'react-router-dom';
import { Market } from '../types';

import { formatRelativeTime } from '../utils/utils';

interface MarketCardProps {
  market: Market;
}

const MarketCard: React.FC<MarketCardProps> = ({ market }) => {
  return (
    <Link to={`/token/${market.ContractAddress}`} className="market-card-link">
      <div className="market-card">
        <div
          className="market-card-image"
          style={{ backgroundImage: `url(../game-images/${market.LogoUrl})` }}
        />
        <div className="market-card-content">
          {market.PercentageChange !== undefined && (
            <span className={`percentage ${market.PercentageChange >= 0 ? 'positive' : 'negative'}`}>
              Price: ${market.CurrentPrice} ({market.PercentageChange >= 0 ? '+' : ''}{market.PercentageChange.toFixed(2)}%)
            </span>
          )}
          <h2>{market.Name} ({market.Symbol})</h2>
          <p>{market.Description}</p>
          <div className="bonding-curve-info">
            <h3>Bonding Curve Progress: {market.BondingCurveProgress.toFixed(2)}%</h3>
            <div className="progress-bar">
              <div className="progress" style={{width: `${market.BondingCurveProgress}%`}}></div>
            </div>
          </div>
          <div className="market-stats">
            <span>Market Cap: ${market.MarketCap.toLocaleString()}</span>
            <span>{market.MarketCapChange.toFixed(2)}%</span>
          </div>
          <div className="market-stats">
            <span>24H Volume: $4k</span>
            <span>Created: {formatRelativeTime(market.LaunchTime)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default MarketCard;